'use client';

import { createClient as createSupabaseClient, SupabaseClient } from '@supabase/supabase-js';

// Singleton instance — all code shares the same client so session state is consistent
let supabaseInstance: SupabaseClient | null = null;

export function createClient(): SupabaseClient {
  if (supabaseInstance) return supabaseInstance;

  supabaseInstance = createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        persistSession: true,
        storageKey: 'qhsepro-auth',
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    }
  );

  return supabaseInstance;
}

export function resetClient() {
  // Allow resetting the singleton (e.g. after sign-out) so a fresh client is created next time
  supabaseInstance = null;
}
